/**
 * The kinds of patient money an encounter can carry: the EOB's patient-responsibility split
 * (co-pay, deductible, co-insurance — docs/GLOSSARY.md "Billing") and the self-pay visit fee
 * of an uninsured visit (PD-1943). Each kind has at most one Invoice per encounter.
 * Lives in a `*.contract.ts` file so the oRPC copay contracts can import it across the web
 * package boundary (the bundle guard only lets `*.contract.ts` / `contracts.ts` cross from
 * middleware) — no imports here.
 */
export const PATIENT_INVOICE_KINDS = ['copay', 'deductible', 'coinsurance', 'self-pay'] as const
export type PatientInvoiceKind = (typeof PATIENT_INVOICE_KINDS)[number]

/**
 * The three kinds the insurance EOB splits the patient responsibility into. Record payment's
 * breakdown, its draft Invoices and the console's EOB form iterate THIS list — self-pay is a
 * visit fee, never part of a patient responsibility.
 */
export const EOB_RESPONSIBILITY_KINDS = ['copay', 'deductible', 'coinsurance'] as const
export type EobResponsibilityKind = (typeof EOB_RESPONSIBILITY_KINDS)[number]

/** Staff-facing names of the kinds: Stripe product name, handler messages, patient link copy. */
export const PATIENT_INVOICE_KIND_LABELS: Record<PatientInvoiceKind, string> = {
  copay: 'co-pay',
  deductible: 'deductible',
  coinsurance: 'co-insurance',
  'self-pay': 'self-pay',
}
